// Shared by AgentsPage (create/config dialogs) and SettingsPage (Roles card).
// Memory permissions are gone on purpose: agents write only their own memory and post change requests;
// the Librarian curates every shared tier.
export const PERMISSIONS = [
    { key: "escalate-human", label: "Send to Human Review" },
    { key: "commit-push", label: "Commit & Push (VCS)" },
    { key: "create-tasks", label: "Create Tasks" },
    { key: "claim-tasks", label: "Claim Tasks" },
    { key: "message-agents", label: "Message Agents" },
    { key: "write-reports", label: "Write Progress Reports (owner)" },
    { key: "record-versions", label: "Record Releases / Versions" },
    { key: "run-simulations", label: "Submit Simulations (smoke jobs ≤ 60 s)" },
    { key: "manage-simulations", label: "Manage Simulations (QA: any runtime, priority, summaries)" },
];
export const DEFAULT_PERMS = ["commit-push", "claim-tasks", "message-agents"];
export const DEFAULT_TOOLS = ["chromium-playwright"];
